import axios from 'axios';
import { apiClient } from '../utils/api';
import { nextRequestsGetSlotsTime, requestsGetSlotsTime, setNextRequestsGetSlotsTime, setRequestsGetSlotsTime } from '../utils/variables';

export async function getTimeSlots(data) {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    setRequestsGetSlotsTime([...requestsGetSlotsTime, source]);
    if (!data.procedure_addon_ids) {
        return await axios.request({
            headers: {
                ...apiClient.config().headers,
            },
            cancelToken: source.token,
            method: 'GET',
            url: `${apiClient.apiUrl(`api/events/appointment-channel/${data.id}/slots?start_time=${data.start_time}&end_time=${data.end_time}&${data.procedure_ids}${data?.staff_id ? `&staff_id=${data?.staff_id}` : ""}${data?.location_id ? `&location_id=${data?.location_id}` : ""}`)}`,
        }
        );
    }

    return await axios.request({
        headers: {
            ...apiClient.config().headers,
        },
        cancelToken: source.token,
        method: 'GET',
        url: `${apiClient.apiUrl(`api/events/appointment-channel/${data.id}/slots?start_time=${data.start_time}&end_time=${data.end_time}&${data.procedure_ids}&${data.procedure_addon_ids}${data?.staff_id ? `&staff_id=${data?.staff_id}` : ""}${data?.location_id ? `&location_id=${data?.location_id}` : ""}`)}`,
    }
    );
}

/**
 * Fetch which days in a range have no slots (one API call).
 * Returns { fully_booked_days: ['YYYY-MM-DD', ...] }.
 * Uses same query shape as slots (procedure_ids, procedure_addon_ids as in getTimeSlots).
 */
export async function getFullyBookedDays(appointmentChannelId, data) {
    const base = `api/events/appointment-channel/${appointmentChannelId}/fully-booked-days`;
    const q = [
        `start_time=${data.start_time}`,
        `end_time=${data.end_time}`,
        data.procedure_ids || '',
        data.procedure_addon_ids ? `&${data.procedure_addon_ids}` : '',
        data.staff_id ? `&staff_id=${data.staff_id}` : '',
        data.location_id ? `&location_id=${data.location_id}` : '',
    ].filter(Boolean).join('&');
    const url = apiClient.apiUrl(`${base}?${q}`);
    const res = await axios.request({
        headers: { ...apiClient.config().headers },
        method: 'GET',
        url,
    });
    return res.data;
}

export async function getNextAvailableSlot(appointmentChannelId, data) {
    const CancelTokenNext = axios.CancelToken;
    const sourceNext = CancelTokenNext.source();
    setNextRequestsGetSlotsTime([...nextRequestsGetSlotsTime, sourceNext]);
    return await axios.request({
        method: 'GET',
        headers: {
            ...apiClient.config().headers,
        },
        cancelToken: sourceNext.token,
        url: `${apiClient.apiUrl(`api/events/appointment-channel/${appointmentChannelId}/slots/next?${data?.procedures ? data.procedures : ""}${data?.procedure_addon_ids ? `&${data?.procedure_addon_ids}` : ""}${data?.staff_id ? `&staff_id=${data?.staff_id}` : ""}${data?.location_id ? `&location_id=${data?.location_id}` : ""}`)}`,
    });
}
